import { Box, Container } from "@mui/material";
import { useState } from "react";
import InventoryPageDialogs from "./InventoryComponents/popups/InventoryPageDialogs.js";
import KeyNumberContainer from "./InventoryComponents/KeyNumberContainer.js";
import InventoryTableContainer from "./InventoryComponents/Table/InventoryTableContainer.js";

const InventoryPage = () => {
  const [popupToggles, setPopupToggles] = useState({
    history: false,
    addProduct: false,
    batchEdit: false,
    ganttChart: false,
    batchQrScannerToggle: false,
    batchEditMode: false,
  });

  return (
    <>
      <Container maxWidth="xl" sx={{ paddingTop: 2 }}>
        <InventoryPageDialogs
          popupToggles={popupToggles}
          setPopupToggles={setPopupToggles}
        />

        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <KeyNumberContainer
            popupToggles={popupToggles}
            setPopupToggles={setPopupToggles}
          />
          <InventoryTableContainer
            popupToggles={popupToggles}
            setPopupToggles={setPopupToggles}
          />
        </Box>
      </Container>
    </>
  );
};

export default InventoryPage;
